import * as React from 'react';
import { observer } from 'mobx-react';
import { IShadePicker, IVtoFlag } from '../../interfaces/IVto';

import { VtoCustomShadePicker } from '../common/VtoCustomShadePicker';

interface IVtoMakeupCustomShadePicker {
    vtoMakeupFeature?: IVtoFlag;
    productShadePickerProps: IShadePicker;
}

export const VtoMakeupCustomShadePicker = observer(
    ({ vtoMakeupFeature, productShadePickerProps }: IVtoMakeupCustomShadePicker) => {
        const hasCustomShadePicker = vtoMakeupFeature && vtoMakeupFeature.hasCustomShadePicker;
        const {
            parentProduct: { isShaded }
        } = productShadePickerProps.selectedSku;

        if (!hasCustomShadePicker || !isShaded) {
            return null;
        }

        return <VtoCustomShadePicker {...productShadePickerProps} />;
    }
);
